import * as http from './http';
import { stringify } from 'query-string';
import ApiService from './service';
import {
  User,
  PaginatedApiResponse,
  ApiResponse,
  VehicleModels,
  CreateUserShift,
  UserShiftGrouped,
  UserShift,
  CreateTimeOff,
  UserTimeOffGrouped,
  UserTarget,
  ListSort,
} from '../models';
import { Dict } from '../../models';
const serviceEndpoint = 'api/user';

export class UserService extends ApiService {
  public async loadAllStaffMembers(
    data: {
      // page: number;
      query?: string;
    } & Dict
  ): Promise<PaginatedApiResponse<User> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/${serviceEndpoint}?${stringify(data)}`;

    const resposne = await http.get<PaginatedApiResponse<User>>(
      url,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async loadStaffMemberDetails(id: string): Promise<User> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}`;

    const resposne = await http.get<ApiResponse<User>>(url, this.store);
    return resposne.data?.data;
  }

  public async createStaffMember(data: User) {
    const url = `${this.apiDomain}/${serviceEndpoint}`;

    const response = await http.post<ApiResponse<User>>(url, data, this.store);

    return response?.data?.data;
  }

  public async updateStaffMember(data: User, id: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}`;

    const response = await http.put<ApiResponse<User>>(url, data, this.store);

    return response?.data?.data;
  }

  public async updateVehicleModels(
    data: { vehicleModels: VehicleModels[] },
    id?: string
  ) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}/vehicle-models`;

    const response = await http.put<ApiResponse<User>>(url, data, this.store);

    return response?.data?.data;
  }

  public async loadShiftGrouped(id?: string): Promise<UserShiftGrouped> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}/shifts/grouped`;

    const resposne = await http.get<ApiResponse<UserShiftGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async createStaffShift(data: CreateUserShift, userId?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/shifts`;

    const response = await http.post<ApiResponse<CreateUserShift>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateStaffShift(
    data: CreateUserShift,
    userId?: string,
    id?: string
  ) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/shifts/${id}`;

    const response = await http.put<ApiResponse<CreateUserShift>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async removeUserShift(userId?: string, id?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/shifts/${id}`;

    const response = await http.remove<UserShift>(url, this.store);

    return response?.data;
  }

  public async createUserTimeOff(data: CreateTimeOff, userId?: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/time-off`;

    const response = await http.post<ApiResponse<CreateTimeOff>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async updateUserTimeOff(
    data: CreateTimeOff,
    userId?: string,
    id?: string
  ) {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/time-off/${id}`;

    const response = await http.put<ApiResponse<CreateTimeOff>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async removeUserTimeOff(id?: string) {
    const url = `${this.apiDomain}/api/events/${id}`;

    const response = await http.remove<UserShift>(url, this.store);

    return response?.data;
  }

  public async loadUserTimeOfftGrouped(
    id?: string
  ): Promise<UserTimeOffGrouped> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}/time-off/grouped`;

    const resposne = await http.get<ApiResponse<UserTimeOffGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async loadUserTimeOff(id?: string): Promise<UserTimeOffGrouped> {
    const url = `${this.apiDomain}/api/events/grouped-timeoffs`;

    const resposne = await http.post<ApiResponse<UserTimeOffGrouped>>(
      url,
      {
        assignedPersonIds: [id],
      },
      this.store
    );
    return resposne?.data?.data;
  }

  public async getSalesPersons(
    data?: { list?: string } & ListSort
  ): Promise<User[]> {
    const url = `${this.apiDomain}/${serviceEndpoint}/sales-persons?${stringify(
      data || {}
    )}`;

    const resposne = await http.get<PaginatedApiResponse<User>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async getCrmAgents(data?: {} & ListSort): Promise<User[]> {
    const url = `${this.apiDomain}/${serviceEndpoint}/crm-agents?${stringify(
      data || {}
    )}`;

    const resposne = await http.get<PaginatedApiResponse<User>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async getAllStaffs(
    data?: { showroomId?: string } & ListSort
  ): Promise<User[]> {
    const url = `${this.apiDomain}/${serviceEndpoint}/staffs?hideBlocked=true&${stringify(
      data || {}
    )}`;
    // if (showroomId != null) {
    //   url += '&showroomid=' + showroomId;
    // }

    const resposne = await http.get<PaginatedApiResponse<User>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async getVisibleUsers(
    data?: { showroomId?: string } & ListSort
  ): Promise<User[]> {
    const url = `${this.apiDomain}/${serviceEndpoint}/visible-users?${stringify(
      data || {}
    )}`;
    // if (showroomId != null) {
    //   url += '&showroomid=' + showroomId;
    // }

    const resposne = await http.get<PaginatedApiResponse<User>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getAllLandlordsByProposedPropertyId(
    id?: string
  ): Promise<User[]> {
    const url = `${this.apiDomain}/api/proposal/proposed-property/landlords/${id}`;

    const resposne = await http.get<any>(
      url,
      this.store
    );
    return resposne?.data.proposedPropertyStatus
  }

  public async downloadUser(

    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/${serviceEndpoint}/list/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      'application/application/vnd.openxmlformats',
      `Staffs-${new Date()}.xlsx`
    );
  }

  public async getUserProfilePhoto(id?: string): Promise<string> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}/profile-photo`;

    const resposne = await http.get<ApiResponse<string>>(url, this.store);

    return resposne?.data?.data;
  }

  public async getAllTargets(userId?: string): Promise<UserTarget[]> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/targets`;
    const resposne = await http.get<ApiResponse<UserTarget[]>>(url, this.store);
    return resposne.data?.data;
  }
  public async getMonthlyTargetOfManager(
    showroomIds?: string[],
    month?: string,
    year?: string,
    salesManIds?: string[]
  ): Promise<number> {
    const data = { showroomIds, month, year, salesManIds };
    const url = `${this.apiDomain}/${serviceEndpoint}/manager/targets`;
    const resposne = await http.put<ApiResponse<number>>(url, data, this.store);
    return resposne.data?.data;
  }

  public async createTarget(
    updateData: UserTarget,
    userId?: string
  ): Promise<ApiResponse<UserTarget[]>> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/targets`;
    const resposne = await http.post<ApiResponse<UserTarget[]>>(
      url,
      updateData,
      this.store
    );
    return resposne.data;
  }

  public async updateTarget(
    updateData: UserTarget,
    userId?: string,
    targetId?: string
  ): Promise<ApiResponse<UserTarget[]>> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/targets/${targetId}`;
    const resposne = await http.put<ApiResponse<UserTarget[]>>(
      url,
      updateData,
      this.store
    );
    return resposne.data;
  }
  public async deleteTarget(
    userId?: string,
    targetId?: string,
    model?: string
  ): Promise<ApiResponse<UserTarget[]>> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${userId}/targets/${targetId}/${model}`;
    const resposne = await http.remove<ApiResponse<UserTarget[]>>(
      url,
      this.store
    );
    return resposne.data;
  }
  public async getSalesmanMonthlyTargets(id: string, year: string) {
    const url = `${this.apiDomain}/api/user/:${id}/targets/${year}`;

    const resposne = await http.get<ApiResponse<UserTarget[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async forceLogoutStaff(id: string): Promise<User> {
    const url = `${this.apiDomain}/${serviceEndpoint}/${id}/force-logout`;

    const resposne = await http.post<ApiResponse<User>>(url, {}, this.store);
    return resposne.data?.data;
  }

  public async getUserList(): Promise<any> {
    const url = `${this.apiDomain}/api/user?hideBlocked=true`;
    const response = await http.get<any>(url, this.store);
    return response?.data?.data || [];
  }
}
